import Avatar                             from '../../avatar'
import classnames                         from 'classnames'
import moment                             from 'moment'
import { useContext }                     from 'react'
import { ChatWsContext,ChatContext }      from '..'

import {
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardBody,
  CardImg,
} from "reactstrap"

import {
  MoreVertical,
  CornerUpRight
} from 'react-feather'

import { fallbackImage_ } from '../../../../helpers/default_helper'

export const CardMessage = (props) => {

  const {
    setVisibilityModalForwardMessage
  } = useContext(ChatContext)

  const {
    uuid,
    revokeMessageSelf,
    revokeMessageAll,
    setSelectedMessage,
    setForwardMessage
  } = useContext(ChatWsContext)

  const handleForwardMessage = (item) => {
    setVisibilityModalForwardMessage(true)
    setForwardMessage(item)
  }

  let isSender = props.message.sender.uuid === uuid

  return (
    <div
      className={classnames('chat', {
        'chat-left': !isSender
      })}
    >
      <UncontrolledButtonDropdown className="d-block">
        {
          props.currentSender !== props.message.sender_id ?
            (
              <div className='chat-avatar'>
                <Avatar
                  onError={fallbackImage_}
                  className='box-shadow-1 cursor-pointer'
                  img={props.message.sender.avatar}
                />

              </div>
            ) : (
              <div className='chat-avatar'>
                <Avatar
                  onError={fallbackImage_}
                  className='box-shadow-1 cursor-pointer bg-transparent'
                />
              </div>
            )
        }

        <div className='chat-body'>
          <div className='chat-content p-0 mb-0'>
            {
              props.message.content_type === "forward" ? (
                <div className='text-white px-1 pt-1'>
                  <div className={isSender ? "text-white" : "text-primary"}>
                  <CornerUpRight size={20} className='cursor-pointer' />
                    Diteruskan
                  </div>
                </div>
              ) : null
            }
            <div className='px-1 pt-1 pb-0 d-flex justify-content-between'>
              <strong className={isSender ? "text-white" : "text-primary"}>
                {props.message.sender.name}
              </strong>
              <DropdownToggle tag='span' className="p-0" >
                <MoreVertical size={20} className='cursor-pointer' />
              </DropdownToggle>
            </div>

            {
              props.message.parent != null ? (
                <Card className="text-dark m-0 mb-1 p-1 bg-primary rounded-0"
                  style={{ opacity: "0.7" }}
                >
                  <CardBody className="p-1 bg-white rounded">
                    <strong className='text-dark'>
                      {props.message.parent.sender.name}
                    </strong>
                    <br />
                    {props.message.parent.content}
                  </CardBody>
                </Card>
              ) : null
            }
            <div className='px-1 pt-0 pb-1'>
              <div className='p-0'>
                {
                  props.message.attachment !== null ? (
                    props.message.attachment.map((item) => {
                      if (item.type == "Image") {
                        return (
                          <CardImg key={item.id} className='bg-light' src={item.content} style={{ height: "250px" }} />
                        )
                      } else if (item.type == "Document" || item.type == "Other") {
                        return (
                          <Card className="text-dark m-0 mb-1 p-0"
                            style={{ opacity: "0.7" }}
                            key={item.id}
                          >
                            <a href={item.content}>
                              <CardBody className={isSender ? "bg-white p-1 rounded" : "bg-primary p-1 rounded"}>
                                <strong className={isSender ? "text-primary" : "text-white"}>
                                  {item.name}
                                </strong>
                              </CardBody>
                            </a>
                          </Card>
                        )
                      } else if (item.type == "Video") {
                        return (
                          <video key={item.id} src={item.content} style={{ width: "250px" }} controls />
                        )
                      } else if (item.type == "Audio") {
                        return (
                          <audio key={item.id} src={item.content} style={{ width: "250px" }} controls />
                        )
                      }
                    })
                  ) : null
                }
                <p>{props.message.content}</p>
                <p className={`'text-right text-muted text-left'`}>{moment(props.message.created_at).format('DD MMMM YYYY HH:mm')}</p>
              </div>
            </div>
          </div>
        </div>

        <DropdownMenu direction='start'>
          <DropdownItem className='w-100' onClick={() => setSelectedMessage(props.message)}>
            <span className='align-middle'>Balas Percakapan</span>
          </DropdownItem>
          <DropdownItem className='w-100' onClick={() => handleForwardMessage(props.message)}>
            <span className='align-middle'>Teruskan Percakapan</span>
          </DropdownItem>
          <DropdownItem className='w-100' onClick={() => revokeMessageSelf(props.message.id)}>
            <span className='align-middle'>Hapus Untuk Saya</span>
          </DropdownItem>
          {
            isSender ? (
              <DropdownItem className='w-100' onClick={() => revokeMessageAll(props.message.id)}>
                <span className='align-middle'>Hapus Untuk Semua</span>
              </DropdownItem>
            ) : null
          }
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    </div>
  )
}